import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class CustomReport {
    getById(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(
            `${APIPath.customReport}?${params}`,
        )
    }

    getComponent(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(
            `${APIPath.customComponentReport}?${params}`,
        )
    }
}

const CustomReportService = new CustomReport()
Object.freeze(CustomReportService)
export { CustomReportService }
